<template>
   <div class="obi-dashboard">
      <ObiContent isAdmin>
         <template slot="sidebar"> </template>

         <template slot="content">
            <router-view />
         </template>
      </ObiContent>
   </div>
</template>
<script>
export default {
   data() {
      return {
         routeIsDashboard: this.$router.currentRoute.name === 'dashboard-admin',
      };
   },
   watch: {
      $route(newVal) {
         this.routeIsDashboard = newVal.name === 'dashboard-admin';
      },
   },
};
</script>
<style lang="scss" scoped>
.obi-dashboard {
   height: 100%;
   display: grid;
   grid-template-rows: auto 1fr;
   overflow: hidden;
}
.obi-content {
   margin-top: 0px;
   .obi-content--content {
      margin-top: 0px !important;
   }
}
</style>
